const initialState = {
  weeklyMatches: [],
  pendingMatches: [],
  confirmedMatches: [],
  matchStats: null,
  nextDropCountdown: null,
  emptySlotReason: null,
  matchmakerReadiness: null,
  awaitingFill: false,
  loading: false,
  error: null,
  currentWeekDropId: null,
  pagination: {
    pending: { limit: 20, offset: 0, hasMore: true, total: 0 },
    confirmed: { limit: 20, offset: 0, hasMore: true, total: 0 }
  }
};

const matchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_WEEKLY_MATCHES_REQUEST':
    case 'FETCH_PENDING_MATCHES_REQUEST':
    case 'FETCH_CONFIRMED_MATCHES_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FETCH_WEEKLY_MATCHES_SUCCESS':
      return {
        ...state,
        loading: false,
        weeklyMatches: action.payload?.matches || [],
        currentWeekDropId: action.payload?.drop_id || null,
        emptySlotReason: action.payload?.empty_slot_reason || null,
        matchmakerReadiness: action.payload?.matchmaker_readiness || null,
        awaitingFill: action.payload?.awaiting_fill === true,
        error: null
      };

    case 'FETCH_PENDING_MATCHES_SUCCESS':
      return {
        ...state,
        loading: false,
        pendingMatches: action.payload?.append
          ? [...state.pendingMatches, ...(action.payload?.matches || [])]
          : (action.payload?.matches || []),
        pagination: {
          ...state.pagination,
          pending: {
            ...state.pagination.pending,
            hasMore: action.payload?.has_more || false,
            total: action.payload?.total || 0,
            offset: (action.payload?.offset || 0) + (action.payload?.matches?.length || 0)
          }
        },
        error: null
      };

    case 'FETCH_CONFIRMED_MATCHES_SUCCESS':
      return {
        ...state,
        loading: false,
        confirmedMatches: action.payload?.append
          ? [...state.confirmedMatches, ...(action.payload?.matches || [])]
          : (action.payload?.matches || []),
        pagination: {
          ...state.pagination,
          confirmed: {
            ...state.pagination.confirmed,
            hasMore: action.payload?.has_more || false,
            total: action.payload?.total || 0,
            offset: (action.payload?.offset || 0) + (action.payload?.matches?.length || 0)
          }
        },
        error: null
      };

    case 'FETCH_NEXT_DROP_COUNTDOWN_SUCCESS':
      return {
        ...state,
        nextDropCountdown: action.payload
      };

    case 'FETCH_MATCH_STATS_SUCCESS':
      return {
        ...state,
        matchStats: action.payload || null
      };

    case 'LIKE_MATCH_SUCCESS':
    case 'PASS_MATCH_SUCCESS':
      return {
        ...state,
        pendingMatches: state.pendingMatches.filter(
          m => m.id !== action.payload.matchId
        )
      };

    case 'UNMATCH_SUCCESS':
      return {
        ...state,
        confirmedMatches: state.confirmedMatches.filter(
          m => m.id !== action.payload.matchId
        )
      };

    case 'FETCH_WEEKLY_MATCHES_FAILURE':
    case 'FETCH_PENDING_MATCHES_FAILURE':
    case 'FETCH_CONFIRMED_MATCHES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default matchesReducer;
